export const ACTION_DETECT_COUNTRY_GEO = 'ACTION_DETECT_COUNTRY_GEO';
export const ACTION_FETCH_USER_INFO = 'ACTION_FETCH_USER_INFO';
export const ACTION_FETCH_USER_DATA = 'ACTION_FETCH_USER_DATA';
